import './App.css';
import { useState } from 'react';
import WidgetPopup from './commponents/WidgetPopup';

// import Testing from './page/Testing';
import ActiveIcon from './commponents/images/ActiveIcon';
import MainIcon from './commponents/images/MainIcon';
import { PARAMETER_EVENT } from './utils/constants';

function App() {

  const [widgetPosition, setWidgetPosition] = useState(
    localStorage.getItem("progatixWidgetPosition")
      ? localStorage.getItem("progatixWidgetPosition")
      : PARAMETER_EVENT.LEFT
  )
  const [state, setState] = useState(
    localStorage.getItem("progatixWidget")
      ? localStorage.getItem("progatixWidget")
      :PARAMETER_EVENT.CLOSE
  );
  const toggleState = () => {
    if (state === PARAMETER_EVENT.OPEN) {
      setState(PARAMETER_EVENT.CLOSE);
      localStorage.setItem("progatixWidget", PARAMETER_EVENT.CLOSE);
    }
    if (state === PARAMETER_EVENT.CLOSE) {
      setState(PARAMETER_EVENT.OPEN);
      localStorage.setItem("progatixWidget", PARAMETER_EVENT.OPEN);
    }
  };
  const togglePsotion = () => {
    if (widgetPosition === PARAMETER_EVENT.RIGHT) {
      setWidgetPosition(PARAMETER_EVENT.LEFT);
      localStorage.setItem("progatixWidgetPosition", PARAMETER_EVENT.LEFT);
    }
    if (widgetPosition === PARAMETER_EVENT.LEFT) {
      setWidgetPosition(PARAMETER_EVENT.RIGHT);
      localStorage.setItem("progatixWidgetPosition", PARAMETER_EVENT.RIGHT);
    }
  };



  //  SCRIPT ADDED ANOTHER PROJECT  //

  // let body = document.getElementsByTagName('body')[0];

  // const appendScript = (url, target = 'head', onload = null) => {
  //   var script = document.createElement("SCRIPT");
  //   script.setAttribute("defer", "");
  //   script.src = url;
  //   script.type = 'text/javascript';
  //   script.onload = onload;
  //   document.getElementsByTagName(target)[0].appendChild(script);
  // };

  // const appendStyle = (url) => {
  //   var style = document.createElement("LINK");
  //   style.href = url;
  //   style.rel = 'stylesheet';
  //   document.getElementsByTagName("head")[0].appendChild(style);
  // };

  // window.addEventListener('load', function (event) {
  //   let widgetRoot = document.createElement('div');
  //   body.appendChild(widgetRoot);
  //   widgetRoot.id = 'progatixWidgetRoot';
  //   appendScript('http://172.17.1.90:50715/static/main.js', 'body', function () { });
  //   appendStyle('http://172.17.1.90:50715/static/css/main.0d6c7b77.css');
  //   appendScript('http://172.17.1.90:50715/static/js/453.ff54e381.chunk.js', 'body', function () { });
  //   appendScript('http://172.17.1.90:50715/static/js/main.b2556fa8.js', 'body', function () { });
  // });

  return (
    <>
    {/* //   RCP TOOL */}
      {/* <Testing toggleState={toggleState} /> */}
      <main
        className="App"
        id="progatixWidget"
        data-accessibility={"progatix-widget"}
        aria-label="Accessibility Widget"
        role="region"
        tabIndex={0}
      >
        <button aria-label="Accessibility Widget"
          style={{ left: widgetPosition === PARAMETER_EVENT.RIGHT && "15px", right: widgetPosition === PARAMETER_EVENT.RIGHT && "inherit" }}
          className="wrapperWidgetIcon"
          onClick={(e) => {
            toggleState();
          }}
        >
          <i style={{ display: "none" }}>0</i>
          <MainIcon />
          <ActiveIcon />
        </button>
        <div style={{ left: widgetPosition === PARAMETER_EVENT.RIGHT && "70px", right: widgetPosition === PARAMETER_EVENT.RIGHT && "inherit" }}
          className={`progatixBody ${state}`}
          aria-label="Accessibility Widget"
          role="region"
          id="widgetMainPopupContainer"
        >
          <WidgetPopup toggleState={toggleState} togglePsotion={togglePsotion} setState={setState} />
        </div>
      </main>
    </>
  );
}

export default App;
